import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';

type TLegalItem = {
	title: string;
	content: string;
};

const DISTRIBUTED_BY_KEY = '2';

type DTicketLegalSectionProps = {
	companyName?: string;
};

export const DTicketLegalSection = ({
	companyName,
}: DTicketLegalSectionProps) => {
	const { t } = useTranslation('userDTicket');
	const legalItemsObj = t('legal_section', {
		returnObjects: true,
	}) as Record<string, TLegalItem>;
	// Fallback to translation if company name is not provided
	const legalItems = Object.entries(legalItemsObj).map(([key, item]) => ({
		key,
		...(key === DISTRIBUTED_BY_KEY && companyName
			? { ...item, content: companyName }
			: item),
	}));

	return (
		<Stack gap={2}>
			{legalItems.map(({ key, title, content }) => (
				<Stack key={title} gap={0.5}>
					<Typography variant="l1" color="solutions.600">
						{title}
					</Typography>
					<Typography
						variant="b2"
						color="primary.main"
						data-testid={`dticket-legalSection-item-${key}`}
					>
						{content}
					</Typography>
				</Stack>
			))}
		</Stack>
	);
};
